export default __webpack_public_path__ + "static/media/undraw_warning_cyit.d1118f7c.svg";